import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import LandingPage from "./pages/LandingPage";
import MarketplacePage from "./pages/MarketplacePage";
import ConnectorPage from "./pages/ConnectorPage";
import SandboxPage from "./pages/SandboxPage";
import DashboardPage from "./pages/DashboardPage";
import HealthPage from "./pages/HealthPage";
import RequestsPage from "./pages/RequestsPage";
import TemplatesPage from "./pages/TemplatesPage";
import CommunityPage from "./pages/CommunityPage";
import SubmitConnectorPage from "./pages/SubmitConnectorPage";
import GeneratorPage from "./pages/GeneratorPage";
import DiscoveryPage from "./pages/DiscoveryPage";
import HowItWorksPage from "./pages/HowItWorksPage";
import "./App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-background">
          <Navbar />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />
            <Route path="/marketplace" element={<MarketplacePage />} />
            <Route path="/connector/:id" element={<ConnectorPage />} />
            <Route path="/sandbox" element={<SandboxPage />} />
            <Route path="/sandbox/:connectorId" element={<SandboxPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/health" element={<HealthPage />} />
            <Route path="/requests" element={<RequestsPage />} />
            <Route path="/templates" element={<TemplatesPage />} />
            <Route path="/community" element={<CommunityPage />} />
            <Route path="/submit" element={<SubmitConnectorPage />} />
            <Route path="/generator" element={<GeneratorPage />} />
            <Route path="/discovery" element={<DiscoveryPage />} />
          </Routes>
          <Toaster 
            position="top-right" 
            toastOptions={{
              style: {
                background: 'hsl(217, 33%, 12%)',
                border: '1px solid hsl(217, 33%, 17%)',
                color: 'hsl(210, 40%, 98%)',
              },
            }}
          />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
